import React, { Fragment } from 'react';

import GenericHeader from '@common-components/pageHeader/GenericHeader';
import Image from '@common-components/image/Image';


export default function SystemErrorMessageForAll( { errorImage, login } ) {
    return (
        <Fragment>
            <div className="grid-row grid-gap gi-wrapper gi-fallback">
                <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__content">
                    <GenericHeader
                        tag="h1"
                        id="error-header"
                        text="session.error.header"
                        headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__header']}
                    />
                    <GenericHeader
                        tag="p"
                        id="error-content"
                        text="session.error.content"
                        headerClassName={['mobile:grid-col-12 tablet:grid-col-fill gi-fallback__content__msg']}
                        linkClassName={['usa-link gi-fallback__content__link']}
                        isReplacementALink={ true }
                        path={login}
                        linkText="session.error.content.link.text"
                    />
                </div>
                <div className="desktop:grid-col-5 tablet:grid-col-5 mobile:grid-col-12 gi-fallback__item gi-fallback__item gi-fallback__img">
                    <Image
                        source= {errorImage}
                        desc="Something went wrong error image"
                        name="system__error_img"
                        classes={[]}

                    />
                </div>
            </div>
        </Fragment>
    );
}